import './Activity.sass';

import React from 'react';
import { Col, Row } from 'react-bootstrap';

import ActivityModal from './ActivityModal';

// List of actions that have information to display in the modal
const ACTIONS_WITH_DETAILS = [
  'subscriptionSetToCancel',
  'subscriptionSetToCancelByUser',
  'subscriptionSetToCancelByAdmin',
  'subscriptionCancelFailed',
  'subscriptionCanceled',
  'subscriptionImmediateChanged',
  'rateChanged',
  'rateChangedByUser',
  'rankChanged',
  'dutyStateChanged',
];

class CardRow extends React.Component {
  state = {};

  openActivityModal = () => {
    if (ACTIONS_WITH_DETAILS.includes(this.props.actions)) {
      this.props.openModal({
        modalContent: (
          <ActivityModal
            actions={this.props.actions}
            closeModal={this.props.closeModal}
            userEmail={this.props.userEmail}
            messageError={this.props.messageError}
            from={this.props.from}
            to={this.props.to}
          />
        ),
        modalTitle: 'User activity',
        modalClassName: 'modal-create-reference',
        className: '',
      });
    }
  };

  render() {
    const hasDetails = ACTIONS_WITH_DETAILS.includes(this.props.actions);

    return (
      <Row
        style={
          this.props.margin
            ? { width: '100%', marginTop: '9px' }
            : { width: '100%' }
        }
      >
        <Col
          xs={this.props.link || this.props.status ? 9 : 4}
          md={this.props.link || this.props.status ? 9 : 4}
          lg={this.props.link || this.props.status ? 9 : 4}
          style={{ paddingRight: '0px' }}
        >
          <div>{this.props.title}</div>
        </Col>
        <Col
          xs={this.props.link || this.props.status ? 3 : 6}
          md={this.props.link || this.props.status ? 3 : 6}
          lg={this.props.link || this.props.status ? 3 : 6}
          style={{ paddingLeft: '0px' }}
        >
          {hasDetails && this.props.link && (
            <div className="link" onClick={() => this.openActivityModal()}>
              {this.props.link}
            </div>
          )}
        </Col>
        <Col style={{ marginTop: '13px' }} xs={12} md={12} lg={12}>
          {this.props.content}
        </Col>

        <div className="separatorLine" />
      </Row>
    );
  }
}

export default CardRow;
